module.exports = __webpack_public_path__ + "img/slide_1st_bg.b77e4b46.svg";